import type { VehicleState } from 'Pages/vehicles/helpers/vehicle.schema';
import dayjs from 'Utilities/dayjs';
import { SOLD_CATEGORY } from 'Utilities/vehicleState';

interface GetIsPurchaseSummaryAllowedParams {
	soldDate?: Nullable<string>;
	state?: VehicleState;
}

const PURCHASE_SUMMARY_APPLICABLE_STATES = [SOLD_CATEGORY.SOLD_DOCUMENTS_REVIEWED, SOLD_CATEGORY.SOLD_CONFIRMED];
export const PURCHASE_SUMMARY_CUTOFF_DATE = dayjs('2025-02-26T17:00:00Z');

// Non-hook version for getServerSideProps
export const getIsPurchaseSummaryAllowed = ({ soldDate, state }: GetIsPurchaseSummaryAllowedParams) => {
	const parsedSoldDate = dayjs(soldDate);
	const cutoffDateCondition = Boolean(
		soldDate && parsedSoldDate.isValid() && parsedSoldDate.isSameOrAfter(PURCHASE_SUMMARY_CUTOFF_DATE),
	);

	return Boolean(cutoffDateCondition && state && PURCHASE_SUMMARY_APPLICABLE_STATES.includes(state.slug));
};

interface UseIsPurchaseSummaryAllowedParams {
	soldDate?: string;
	state: VehicleState;
}

export const useIsPurchaseSummaryAllowed = ({ soldDate, state }: UseIsPurchaseSummaryAllowedParams) => {
	return getIsPurchaseSummaryAllowed({ soldDate, state });
};
